// eslint-disable-next-line no-useless-escape
export const regexEmail = /^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}$/i

export const validateEmail = (email: string): boolean =>
  regexEmail.test(email)

export const validateImage = (mime: string): boolean =>
  ['image/jpeg', 'image/png'].includes(mime)
